import { render, staticRenderFns } from "./FrzChamberGroupingPallets.vue?vue&type=template&id=880bd3c0"
import script from "./FrzChamberGroupingPallets.vue?vue&type=script&lang=js"
export * from "./FrzChamberGroupingPallets.vue?vue&type=script&lang=js"
import style0 from "./FrzChamberGroupingPallets.vue?vue&type=style&index=0&id=880bd3c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports